import { createV3Queries } from "@query/utils/createV3Queries";
import { oauthApi } from "@api";

export const queriesOAuth = createV3Queries("oauthApi", oauthApi);
